
























































































import Vue from "vue";
export default Vue.extend({
  name: "HexagonAvatar",
  props: {
    imgSrc: String,
  },
  computed: {
    hexagonStyle(): string {
      let style = `position: absolute;`;
      switch (this.$vuetify.breakpoint.name) {
        case "sm":
          return style + "left: 32px;";
        case "md":
          return style + "left: 308px;";
        case "xl":
          return style + "left:222px;";
        default:
          return style;
      }
    },
  },
});
